import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import Vue from 'vue';
import $ from 'jquery'
import VueHtml2pdf from 'vue-html2pdf'
import { convertDateToDdMmYyyy } from '@/function/function.js';
Vue.use(VueHtml2pdf)
export default {
  name: 'resultat-tdr',
  components: {
    VueHtml2pdf, EnteteBonEtFacture
  },
  props: [],
  data () {
    return {
      date_resultat: '', 
      result_loading: true
    }
  },
  computed: {
        prescripteur(){
          return this.$store.getters["prescripteur"];
      },
      resultat(){
          return this.$store.getters["resultat"];
      },

  },
  mounted () {
      setTimeout(() => {
        $('.shw').fadeIn()
    }, 500);
    this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());

    this.$store.dispatch("getDemandeResult",this.$route.params.resultat_id).then(
      () =>{
          this.result_loading = false
          if(this.resultat.user_id !== null)
          {
              this.$store.dispatch("getPrescripteur",this.resultat.user_id)
          }
          else{
              this.$store.commit("SET_PRESCRIPTEUR",null)
          }
          
          
      }
  )



  },
  methods: {
    printResultatTDR() {
      this.$refs.tdr_html2Pdf.generatePdf()
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
          // const totalPages = pdf.internal.getNumberOfPages()

          let foot_content = 'Généré(e) via l\'application Clinicaa';

          let la_caisse = 'Le biologiste';
          let lome_le = this.ville_le+this.date_resultat;

          // LOME LE
          pdf.setTextColor(150)
          pdf.setFontSize(10)
          pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1.4))

          // LA CAISSE
          pdf.setTextColor(150)
          pdf.setFontSize(10)
          pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1.4))

          // FOOTER
          pdf.setTextColor(150)
          pdf.setFontSize(8)
          pdf.text(foot_content, (2.0), (pdf.internal.pageSize.getHeight() - 0.3))
      }).save()
  },

  onProgress(ev) {
      console.log(ev)
  },  
  
  hasStartedGeneration() {
      
  },  

  hasGenerated(ev) {
      console.log(ev)
  }

  }
}


